import { FC, useEffect, useState } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import type { FlightFilters as FlightFiltersType, AirlineOption, AirportOption } from '../../../../../types/flight.types';
import FlightFilters from '../FlightFilters/FlightFilters';
import CustomButton from '../../../../../common/CustomButton';

import styles from './FlightFiltersModal.module.scss';

type FlightFiltersModalProps = {
  open: boolean;
  onClose: () => void;
  filters: FlightFiltersType;
  onApply: (next: FlightFiltersType) => void;
  airlineOptions: AirlineOption[];
  airportOptions: AirportOption[];
};

const FlightFiltersModal: FC<FlightFiltersModalProps> = ({
  open,
  onClose,
  filters,
  onApply,
  airlineOptions,
  airportOptions,
}) => {
  const [draft, setDraft] = useState<FlightFiltersType>(filters);

  useEffect(() => {
    if (open) {
      setDraft(filters);
    }
  }, [open, filters]);

  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(34, 43, 58, 0.35)' },
        },
      }}
      PaperProps={{
        className: styles.drawerPaper,
        elevation: 8,
      }}
    >
      <Box className={styles.header}>
        <Typography
          variant="h8Bold"
          className={styles.title}
        >
          Filters
        </Typography>
        <IconButton
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close filters"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className={styles.body}>
        <FlightFilters
          filters={draft}
          onFiltersChange={setDraft}
          airlineOptions={airlineOptions}
          airportOptions={airportOptions}
        />
      </Box>

      <Box className={styles.footer}>
        <CustomButton
          variant="outlined"
          btnType="button"
          onClick={onClose}
          customClass={styles.footerBtn}
        >
          Cancel
        </CustomButton>
        <CustomButton
          variant="contained"
          btnType="button"
          onClick={handleApply}
          customClass={styles.footerBtn}
        >
          Apply filters
        </CustomButton>
      </Box>
    </Drawer>
  );
};

export default FlightFiltersModal;
